const state = {
    users: [],
    statusMessage: null
}
export default state;